import React from 'react';
import ReactDOM from 'react-dom/client';
import Router from './app/Router';
import {QueryProvider} from './query';
import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: 'https://435c4f6839601b95f6b56d61a2278106@o4507293711335424.ingest.de.sentry.io/4507293713694800',
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ['stg-web2.duverify.com', 'web2.duverify.com'],
  // Session Replay
  enabled: import.meta.env.PROD,
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryProvider>
      <Router />
    </QueryProvider>
  </React.StrictMode>,
);
